import { createAction, props } from '@ngrx/store';

import { Additional } from '../../pages/additionals/additional';
import { Label } from '../../classes/label';
import { Category } from '../../pages/categories/category';
import { Order } from '../../pages/orders/order';
import { Product } from '../../pages/products/product';
import { Subcategory } from '../../pages/subcategories/subcategory';

export const selectOrder = createAction(
  '[Orders] Select order',
  props<{ order: Order}>()
);

export const unSelectOrder = createAction('[Orders] Unselecte order');

export const setCategoryList = createAction(
  '[Orders] Set category list',
  props<{ category: Category[] }>()
);

export const setSubcategyStack = createAction(
  '[Orders] Set subcategory Stack',
  props<{ subcategoryStack: Map<string, Subcategory[]> }>()
);

export const setProductStack = createAction(
  '[Orders] Set product Stack',
  props<{ productStack: Map<string, Product[]> }>()
);

export const setAdditionalStack = createAction(
  '[Orders] Set additional Stack',
  props<{ addStack: Map<string, Additional[]> }>()
);

export const setLabelNotesStack = createAction(
  '[Orders] Set label notes Stack',
  props<{ labelNotesStack: Map<string, Label[]> }>()
);
